<template>
  <v-row>
    <v-col class="px-2" cols="12" sm="6" md="3">
      <v-row no-gutters>
        <v-col>
          <date-picker prepend-icon="fa-calendar" :model.sync="contextFromDate" :clearable="true" :label="$t('global.fromDate')" class="px-2" />
        </v-col>
        <v-col>
          <date-picker prepend-icon="fa-calendar" :model.sync="contextToDate" :clearable="true" :label="$t('global.toDate')" class="px-2" />
        </v-col>
      </v-row>
    </v-col>

    <v-col class="px-2" cols="12" sm="6" md="2">
      <v-select
        multiple
        v-model="contextSelectedTypes"
        prepend-icon="fa-hand-holding-usd"
        :label="$t('global.serviceTypes')"
        hide-details
        small-chips
        :items="availableServiceTypes"
        item-text="name"
        item-value="type"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0" color="primary" text-color="white">
            <span v-if="item.name.length < 13">
              {{ item.name }}
            </span>
            <span v-else> {{ item.name.substring(0, 13) }}... </span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">(+{{ selectedTypes.length - 1 }} {{ $t("global.others") }})</span>
        </template>
      </v-select>
    </v-col>
    <v-col class="px-2" cols="6" sm="6" md="2">
      <v-checkbox :label="$t('global.expandAll')" v-model="contextShowAll" />
    </v-col>
    <v-spacer />
    <v-col class="px-2" cols="12" sm="6" md="3">
      <v-row no-gutters>
        <booking-column-select :available-columns.sync="availableColumns" :selected-columns.sync="contextSelectedColumns" style="max-width: 80%" />
        <v-tooltip bottom v-if="downloadable">
          {{ $t("global.downloadFile") }}
          <template v-slot:activator="{ on }">
            <v-btn :disabled="$store.getters['Ajax/loading']" @click="$emit('download')" icon v-on="on" large class="mt-3">
              <v-icon large>cloud_download</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from "../../CustomInputComponents/DatePicker";
import BookingColumnSelect from "../BookingColumnSelect";
export default {
  name: "BookingReportBaseFilters",
  components: { BookingColumnSelect, DatePicker },
  props: {
    fromDate: {
      required: true
    },
    toDate: {
      required: true
    },
    selectedTypes: {
      required: true
    },
    selectedColumns: {
      required: true
    },
    availableColumns: {
      required: true
    },
    showAll: {
      required: true
    },
    downloadable: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    availableServiceTypes: [],
    columnDialog: false
  }),
  methods: {
    downloadServiceTypes() {
      this.axios.get("booking/report/get-service-types").then(resp => {
        this.availableServiceTypes = resp.data;
      });
    }
  },
  created() {
    this.downloadServiceTypes();
  },
  computed: {
    contextShowAll: {
      get() {
        return this.showAll;
      },
      set(val) {
        this.$emit("update:showAll", val);
      }
    },
    contextFromDate: {
      get() {
        return this.fromDate;
      },
      set(val) {
        this.$emit("update:fromDate", val);
      }
    },
    contextToDate: {
      get() {
        return this.toDate;
      },
      set(val) {
        this.$emit("update:toDate", val);
      }
    },
    contextSelectedTypes: {
      get() {
        return this.selectedTypes;
      },
      set(val) {
        this.$emit("update:selectedTypes", val);
      }
    },
    contextSelectedColumns: {
      get() {
        return this.selectedColumns;
      },
      set(val) {
        this.$emit("update:selectedColumns", val);
      }
    }
  }
};
</script>

<style scoped></style>
